import fetch from '../core/fetch';

export default class Leads {
  static constructURL() {
    return `${process.env.REACT_APP_CLIENT_LEADS_API}/leads`;
  }

  static async create(email, locale) {
    const url = this.constructURL();
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
      body: JSON.stringify({
        email,
        locale,
      }),
    });
    return response;
  }
}
